<template>
  <div class="min-w-0 overflow-auto bg-n-surface-1 w-full px-3 sm:px-6">
    <div class="max-w-5xl mx-auto pb-12">
      <router-view />
    </div>
  </div>
</template>
